module.exports = __webpack_public_path__ + "static/media/undraw_warning_cyit.947792e8.svg";